import * as Serialize from './serialize';
/**
 * String values
 */
export var StringParam = {
  encode: Serialize.encodeString,
  decode: Serialize.decodeString
};
/**
 * String enum
 */
export var createEnumParam = function createEnumParam(enumValues) {
  return {
    encode: Serialize.encodeString,
    decode: function decode(input) {
      return Serialize.decodeEnum(input, enumValues);
    }
  };
};
/**
 * Numbers (integers or floats)
 */
export var NumberParam = {
  encode: Serialize.encodeNumber,
  decode: Serialize.decodeNumber
};
/**
 * For flat objects where values are strings
 */
export var ObjectParam = {
  encode: Serialize.encodeObject,
  decode: Serialize.decodeObject
};
/**
 * For flat arrays of strings, filters out undefined values during decode
 */
export var ArrayParam = {
  encode: Serialize.encodeArray,
  decode: Serialize.decodeArray
};
/**
 * For flat arrays of strings, filters out undefined values during decode
 */
export var NumericArrayParam = {
  encode: Serialize.encodeNumericArray,
  decode: Serialize.decodeNumericArray
};
/**
 * For any type of data, encoded via JSON.stringify
 */
export var JsonParam = {
  encode: Serialize.encodeJson,
  decode: Serialize.decodeJson
};
/**
 * For simple dates (YYYY-MM-DD)
 */
export var DateParam = {
  encode: Serialize.encodeDate,
  decode: Serialize.decodeDate,
  equals: function equals(valueA, valueB) {
    if (valueA === valueB) return true;
    if (valueA == null || valueB == null) return valueA === valueB;
    // ignore time of day
    return valueA.getFullYear() === valueB.getFullYear() && valueA.getMonth() === valueB.getMonth() && valueA.getDate() === valueB.getDate();
  }
};
/**
 * For dates in simplified extended ISO format (YYYY-MM-DDTHH:mm:ss.sssZ or ±YYYYYY-MM-DDTHH:mm:ss.sssZ)
 */
export var DateTimeParam = {
  encode: Serialize.encodeDateTime,
  decode: Serialize.decodeDateTime,
  equals: function equals(valueA, valueB) {
    if (valueA === valueB) return true;
    if (valueA == null || valueB == null) return valueA === valueB;
    return valueA.valueOf() === valueB.valueOf();
  }
};
/**
 * For boolean values: 1 = true, 0 = false
 */
export var BooleanParam = {
  encode: Serialize.encodeBoolean,
  decode: Serialize.decodeBoolean
};
/**
 * For flat objects where the values are numbers
 */
export var NumericObjectParam = {
  encode: Serialize.encodeNumericObject,
  decode: Serialize.decodeNumericObject
};
/**
 * For flat arrays of strings, filters out undefined values during decode
 */
export var DelimitedArrayParam = {
  encode: Serialize.encodeDelimitedArray,
  decode: Serialize.decodeDelimitedArray
};
/**
 * For flat arrays where the values are numbers, filters out undefined values during decode
 */
export var DelimitedNumericArrayParam = {
  encode: Serialize.encodeDelimitedNumericArray,
  decode: Serialize.decodeDelimitedNumericArray
};